// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__FomhW","approved":"Status_approved__1SxgZ","rejected":"Status_rejected__32Wi9","expired":"Status_expired__2TXCN","label":"Status_label__mgPMB"};